import { Box, FormHelperText, InputLabel, styled } from '@mui/material';
import DatePicker from 'react-datepicker';

import { Modal } from '@atoms';

export const defaultFormControlStyle = {
  backgroundColor: '#fff',
  borderRadius: '10px',
  fontSize: '14px',
  lineHeight: '1.5',
  '& input': {
    fontSize: '14px',
    lineHeight: '1.5',
  },
};

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: 'red',
  marginTop: theme.spacing(0.5),
  height: '20px',
  position: 'absolute',
  bottom: '-20px',
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(0.5),
}));

export const StyledModal = styled(Modal)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '913px',
    borderRadius: '24px',
  },
}));

export const multiLineEllipsisStyle = {
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  whiteSpace: 'pre-line',
};

export const defaultStyleIcon = {
  fill: '#A3A7B0',
  '&:hover': {
    fill: '#44AEFB',
  },
};

export const StyledInputLabel = styled(InputLabel)(() => ({
  fontSize: '11px',
  lineHeight: '16px',
}));

const smallInputBase = {
  '& .MuiInputBase-root': {
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '20px',
  },
};

export const dropdownControllerStyles = {
  maxWidth: '131px',

  '& .MuiOutlinedInput-input': {
    paddingRight: '0 !important',
    paddingY: '6px !important',
  },

  '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    height: '32px',
  },

  '& .MuiFormHelperText-root.Mui-error': {
    marginRight: 0,
  },

  ...smallInputBase,
};

export const textFieldStyles = {
  maxWidth: '368px',

  '& .MuiInputLabel-root': {
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 600,
    span: {
      color: 'red',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '11px !important',
  },
  '& .MuiInputBase-input': {
    paddingY: '8px !important',
  },

  ...smallInputBase,
};

export const DatePickerStyled = styled(DatePicker)`
  height: 35px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
  text-indent: 6px;
  outline: none;
  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.38);
  }

  &:focus,
  &:active {
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
  }

  &::placeholder {
    font-family: 'Plus Jakarta Sans';
    color: rgba(0, 0, 0, 0.38);
    font-weight: 400;
    font-size: 16px;
  }
`;
